import React, { FC } from 'react';
import { paymentAgreement } from '@apply/constants';

export type AcknowledgementProps = {
    acknowledged: boolean;
    setAcknowledged: (acknowledged: boolean) => void;
    showLocTerms: boolean;
};

export const Acknowledgement: FC<AcknowledgementProps> = ({ acknowledged, setAcknowledged, showLocTerms }) => {
    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAcknowledged(e.target.checked);
    };
    return (
        <div className='row appraisal-section appraisal-acknowledgement-section'>
            <div className='columns acknowledgement-section'>
                <div className='title'>Acknowledgement</div>
                <div className='acknowledgement'>
                    <input
                        type='checkbox'
                        id='appraisalAcknowledgement'
                        checked={acknowledged}
                        onChange={onChange}
                    />
                    <label htmlFor='appraisalAcknowledgement'>
                        {showLocTerms && (
                            <>
                                I understand and agree to the following: Applicant is entitled to receive a copy of appraisal
                                report(s). For Line of Credit applications there are refunds. This charge is an estimate. If the
                                actual cost of appraisal report(s) and transaction costs (approximately 3% for credit cards) is
                                less, BFI will provide a refund. If the actual cost of appraisal report(s) and transaction costs
                                is more, BFI reserves the right to bill you. If this payment is used for a type of application
                                other than a Line of Credit, different rules apply and you will not be eligible for a refund.
                                Making this payment does not guaranty that BFI will order appraisal report(s). If BFI does not
                                order appraisal report(s), BFI will attempt to reverse the charges and/or provide a refund less
                                any transaction charges incurred.
                            </>
                        )}
                        {!showLocTerms && <>{paymentAgreement}</>}
                    </label>
                </div>
            </div>
        </div>
    );
};
